/* eslint-disable no-underscore-dangle */
import streamsaver from 'streamsaver';
import ExportFormatter from "./ExportFormatter.js";
streamsaver.mitm = process.env.STREAMSAVER_MITM_URL || 'https://streamsaver-mitm.web.app/mitm.html';
class StreamingExportFormatter extends ExportFormatter {
  constructor(model, opts = {}) {
    super(model, opts);
    if (new.target === StreamingExportFormatter) {
      throw new TypeError('Cannot construct instances of StreamingExportFormatter directly');
    }
    this.textEncoder = new TextEncoder();
  }
  get writer() {
    if (!this._writer) {
      // eslint-disable-next-line security/detect-non-literal-fs-filename
      this._writer = streamsaver.createWriteStream(`${this.exportModel?.filename || 'export'}.${this.model?.extension || 'txt'}`).getWriter();
      window.addEventListener('unload', () => {
        this._writer.abort();
      });
    }
    return this._writer;
  }
  end() {
    this.writer.close();
  }
  onError() {
    this.writer.abort();
  }
}
export default StreamingExportFormatter;